import { Dropdown, assets } from '@round/whitelabel-ui';
import styles from './ActionsCell.module.css';

const { Trash: TrashIcon } = assets;

type Props = {
    onDelete: () => void;
};

const ActionsCell = ({ onDelete }: Props) => {
    return (
        <div className={styles.container}>
            <Dropdown>
                {({ setIsOpen }) => (
                    <>
                        <Dropdown.Target />
                        <Dropdown.Menu>
                            <Dropdown.Item
                                icon={() => <TrashIcon className={styles.delete} />}
                                onClick={() => {
                                    onDelete();
                                    setIsOpen(false);
                                }}
                                className={styles.delete}
                            >
                                Delete post
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </>
                )}
            </Dropdown>
        </div>
    );
};

export default ActionsCell;
